import { createAsyncThunk } from '@reduxjs/toolkit';
import { TableFilter } from '../../../../components/Table/models/table-filter';
import { objectToQueryString } from '../../../../utils/queryHelper';
import createNotification from '../../../../utils/createNotification';

export const GetEngagemets = createAsyncThunk(
    'timeline/getTimelineStages',
    async (filterParams: TableFilter, dispatch: any) => {
        const axios = dispatch.getState().core.axios; 
        const queryString = objectToQueryString(filterParams);
        
        try {
            const response = await axios.get(`/api/Marketplace/Engagements?${queryString}`);

            if (response.status !== 200) {
                createNotification(
                    'Could not fetch Engagements at the moment.',
                    'error'
                );
                throw new Error('Failed to fetch Engagements');
            }

            return {
                timelines: response.data.list,
                pageNumber: response.data.pageNumber,
                totalItems: response.data.totalItems,
                pageSize: response.data.pageSize,
            };
        } catch (error) {
            createNotification(
                'An error occurred while fetching Engagements.',
                'error'
            );
            throw error;
        }
    }
);
